<script setup lang="ts">
import { onMounted, ref } from "vue";

import ArrowIcon from "@/ui/icons/arrow.vue";
import WIDGET_ANALYTICS_EVENTS from "~/tiw/helpers/widgetAnalyticsEvents/widgetAnalyticsEvents";
import { useAnalytics } from "~/tiw/hooks/useAnalytics/useAnalytics";
import useTranslate from "~/tiw/hooks/useTranslate/useTranslate";
import { useTIWStore } from "~/tiw/stores/tiw/tiw";
import Button from "~/tiw/ui/button/button.vue";
import Checkbox from "~/tiw/ui/checkbox/checkbox.vue";

import Modal from "../../modal/modal.vue";

const isConfirmed = ref<boolean>(false);

onMounted(() => {
    useAnalytics(WIDGET_ANALYTICS_EVENTS.BIOMETRIC_VERIFICATION);
});

const TIWStore = useTIWStore();

function onBack() {
    TIWStore.switchStep("chooseRangeDiscount");
    TIWStore.HOLD = true;
}

function onContinue() {
    TIWStore.switchStep("personAuthentication");
}
</script>

<template>
    <Modal class="tiw__confirmBelowPrice">
        <template #header>
            <div class="tiw__confirmBelowPrice__warningIcon">
                <svg
                    width="64"
                    height="58"
                    viewBox="0 0 64 58"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M37.7758 56H26.2258C12.3358 56 5.39084 56 2.82884 51.482C0.269844 46.964 3.82184 40.973 10.9288 28.997L16.7008 19.259C23.5288 7.754 26.9398 2 32.0008 2C37.0618 2 40.4728 7.754 47.3008 19.259L53.0698 29C60.1768 40.976 63.7288 46.967 61.1698 51.485C58.6108 56 51.6658 56 37.7728 56"
                        stroke="#808D9A"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M32 44V30.5"
                        stroke="#F14459"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M32 19.9939V19.9639"
                        stroke="#F14459"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
        </template>
        <div class="tiw__confirmBelowPrice__body">
            <div>
                <p class="tiw__confirmBelowPrice__body__title">
                    {{ useTranslate("tiw__confirmBelowPrice__title") }}
                </p>
                <p class="tiw__confirmBelowPrice__body__text">
                    {{ useTranslate("tiw__confirmBelowPrice__text") }}
                </p>
            </div>
            <Checkbox
                v-model="isConfirmed"
                class="tiw__confirmBelowPrice__body__checkbox"
                :checked="isConfirmed"
            >
                <span v-html="useTranslate('tiw__confirmBelowPrice__checkbox')" />
            </Checkbox>
            <div class="tiw__confirmBelowPrice__body__actions">
                <Button
                    type="button"
                    variant="skeleton"
                    class="tiw__step__chooseSigningType__btn-back"
                    @click="onBack"
                >
                    <ArrowIcon />
                    <span>{{ useTranslate("tiw__back") }}</span>
                </Button>
                <Button :disabled="!isConfirmed" @click="onContinue"> Kontynuuj </Button>
            </div>
        </div>
    </Modal>
</template>

<style lang="scss" src="./confirmBelowPrice.scss" />
